export const API_ROUTES = Object.freeze({
  auth: Object.freeze({
    login: '/auth/login',
    csrf: '/auth/csrf',
    logout: '/auth/logout',
    register: '/auth/register',
    me: '/auth/me',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    verifyEmail: '/auth/verify-email',
    google: '/auth/google',
  }),
  public: Object.freeze({
    health: '/api/health',
    config: '/config/public',
    plans: '/plans/public',
    demoDashboard: '/demo/dashboard',
    explore: '/api/explore',
    sharedAnalysis: (token) => `/api/shared/${token}`,
    eaStore: '/api/store/eas',
    eaStoreDetail: (slug) => `/api/store/eas/${slug}`,
  }),
  app: Object.freeze({
    dashboard: '/api/dashboard',
    accounts: '/api/accounts',
    trades: '/api/trades',
    reports: '/api/reports',
    eaStats: '/api/ea-stats',
    expenses: '/api/expenses',
    notifications: '/notifications',
    alerts: '/alerts',
    payments: '/payments',
    coupons: '/coupons',
    apiKeys: '/api-keys',
  }),
  admin: Object.freeze({
    root: '/api/admin',
    stats: '/api/admin/stats',
    users: '/api/admin/users',
    billing: '/api/admin/billing',
    apiKeys: '/api/admin/api-keys',
    announcements: '/api/admin/announcements',
    logs: '/api/admin/logs',
    featureFlags: '/api/admin/feature-flags',
    plans: '/api/admin/plans',
    wallets: '/api/admin/wallets',
    payments: '/api/admin/payments',
    coupons: '/coupons/admin',
    eaStore: '/api/admin/ea-store',
  }),
  websocket: Object.freeze({
    liveUpdates: '/ws/live-updates',
  }),
});

